import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from './Avatar';

import { PageTitle } from '../PageTitle';
import { useApplication } from '../../AppContext';

const AVATAR_COUNT = 232;
const AVATAR_BASE_NAME = 'AvatarVV_';

function buildAvatarName(index) {
	return `${AVATAR_BASE_NAME}${index.toString().padStart(4, '0')}.png`;
}

const AvatarPicker = () => {

	const app = useApplication();
	const { t } = useTranslation();

	const handleAvatarSelection = React.useCallback((avatarId) => {
		app.userdata.avatar = buildAvatarName(avatarId);
		app.save();
		app.navigate('Profile');
	}, [app]);

	const avatarSection = React.useMemo(() => {
		const avatarNodes = [];

		for (let x = 1; x < AVATAR_COUNT; ++x) {
			const name = buildAvatarName(x);
			avatarNodes.push(
				<li key={x} onClick={() => handleAvatarSelection(x)}>
					<Avatar avatar={name} />
				</li>,
			);
		}

		return avatarNodes;
	}, [handleAvatarSelection]);

	return (
		<div id="JoinWithCode" className="page1">
			<div className="wrapper">
				<PageTitle returnPage="Profile">
					<h1>{t('Avatar')}</h1>
				</PageTitle>
				<ul className="buttonList avatarList">
					{avatarSection}
				</ul>
			</div>
		</div>
	);
};

export default React.memo(AvatarPicker);
